/**
 * @fileoverview
 * Info Card Component - Display information in card format
 * Migrated to new architecture with OnPush change detection
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';


export interface InfoCardItem {
  label: string;
  value: string | number | null | undefined;
}

@Component({
  selector: 'app-info-card',
  standalone: true,
  imports: [CommonModule,FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.css',
})
export class InfoCardComponent {
  @Input() items: InfoCardItem[] = [];
}

